import {
  IPriceAuditLogResponse,
  IPriceAuditStats,
} from "../../models/price-audit/response";
import { IPriceAuditQuery } from "../../models/price-audit/query";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class PriceAuditService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  // Get price audit logs
  getLogs = (query?: IPriceAuditQuery, params?: RequestParams) =>
    this.http.request<IPriceAuditLogResponse>({
      path: `/admin/price-audit/logs`,
      method: "GET",
      query: query,
      ...params,
    });

  // Get price audit statistics
  getStatistics = (
    query?: { from_date?: string; to_date?: string },
    params?: RequestParams
  ) =>
    this.http.request<IPriceAuditStats>({
      path: `/admin/price-audit/statistics`,
      method: "GET",
      query: query,
      ...params,
    });

  // Export to Excel
  exportExcel = (query?: IPriceAuditQuery, params?: RequestParams) =>
    this.http.request<Blob>({
      path: `/admin/price-audit/logs/export`,
      method: "POST",
      body: query,
      format: "blob",
      ...params,
    });
}

export default PriceAuditService;
